export default {
  replySent: "¡Respuesta enviada! Notificación por correo al vendedor",
  internalNoteAdded: "Nota interna añadida",
  sendMessageError: "No se pudo enviar el mensaje",
  ticketMarked: "Ticket marcado como {{label}}",
  updateStatusError: "No se pudo actualizar el estado",
  priorityUpdated: "Prioridad actualizada",
  updatePriorityError: "No se pudo actualizar la prioridad",
} as const;
